/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  ConnextUser,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface UpdateUserInConnextInput {
  deviceId: string;
  email: string;
  userLevel?: number;
  operator?: boolean;
  remove?: boolean;
}
const build = (_query: DocumentNode, input: UpdateUserInConnextInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.email !== undefined ? `$email: String = ${JSON.stringify(input.email).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.userLevel !== undefined ? `$userLevel: Int = ${JSON.stringify(input.userLevel).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.operator !== undefined ? `$operator: Boolean = ${JSON.stringify(input.operator).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.remove !== undefined ? `$remove: Boolean = ${JSON.stringify(input.remove).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    updateUserInConnext(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' } 
      ${ input.email !== undefined ? 'email: $email,' : '' } 
      ${ input.userLevel !== undefined ? 'userLevel: $userLevel,' : '' } 
      ${ input.operator !== undefined ? 'operator: $operator,' : '' } 
      ${ input.remove !== undefined ? 'remove: $remove,' : '' }
    ){
      ...connextuser
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class UpdateUserInConnextMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment connextuser on ConnextUser { ... }
   */
  async execute(_query: DocumentNode, input: UpdateUserInConnextInput): Promise<apollo.FetchResult< { updateUserInConnext: Partial<ConnextUser> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ updateUserInConnext: Partial<ConnextUser> }>({ mutation: build(_query, input) });
  }
}
